import { RequestForStartupProposalDraft } from "@tsTypes/request_for_startup_proposals/draft";
import { RequestForStartupProposalShowResponse } from "@tsTypes/request_for_startup_proposals/show";
import api from "./request";

export const getRfsProposal = async (
  proposalSlug: string
): Promise<RequestForStartupProposalShowResponse> => {
  const response = await api.get(`/request_for_startup_proposals/${proposalSlug}`);
  return response.data;
};

export const getRfsProposalForProposalForm = async (
  proposalSlug: string
): Promise<RequestForStartupProposalDraft> => {
  const response = await api.get(
    `/request_for_startup_proposals/${proposalSlug}?for_proposal_form=true`
  );
  return response.data.proposal;
};

export const updateRfsProposal = async (
  proposalId: number,
  proposal: RequestForStartupProposalDraft
): Promise<RequestForStartupProposalDraft> => {
  const response = await api.put(`/request_for_startup_proposals/${proposalId}`, {
    proposal,
  });
  return response.data.proposal;
};

export const getDraftRfsProposal = async (
  requestSlug: string
): Promise<RequestForStartupProposalDraft | null> => {
  const response = await api.get(`/request_for_startup_proposals/draft/${requestSlug}`);
  return response.data.proposal ?? null;
};

export const saveDraftRfsProposal = async (
  requestSlug: string,
  proposal: RequestForStartupProposalDraft
): Promise<RequestForStartupProposalDraft> => {
  const response = await api.post(`/request_for_startup_proposals/draft/${requestSlug}`, {
    proposal,
  });
  return response.data.proposal;
};
